import { render, staticRenderFns } from "./ChoiceItem.vue?vue&type=template&id=1e612cdb&scoped=true"
import script from "./ChoiceItem.vue?vue&type=script&lang=ts"
export * from "./ChoiceItem.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./ChoiceItem.vue?vue&type=style&index=0&id=1e612cdb&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1e612cdb",
  "0d8e477e"
  
)

export default component.exports